import React, { useState } from "react";
import Select from 'react-select';

import selectStyles from '../../../util/selectStyles';
import listExample from 'images/chatbots/list-options.svg';
import { isTikTokOnlyChatbot } from './utils';
import IconMC from '../../../presentation/components/IconMC';

const buildLabelTypeOption = (type) => {
  let icon;
  let text;
  let message;

  switch (type) {
    case 'text':
      icon = 'number-order'; text = 'Números'; message = 'Mostrará las opciones como una lista de números - texto de opción.';
      break;
    case 'buttons':
      icon = 'fluent-tap-single-20-regular'; text = 'Botones'; message = 'Mostrará las opciones como botones, máximo 3.';
      break;
    case 'list':
      icon = 'list-outline'; text = 'Lista de opciones'; message = 'Mostrará las opciones como una lista desplegable, máximo 10.';
      break;
    default:
      icon = ''; text = ''; message = '';
  }

  return (
    <div className="d-flex flex-row">
      <div className="align-self-center mr-10">
        <IconMC name={icon} size="base" />
      </div>
      <div className="d-flex flex-column align-self-center">
        <span className="fz-12 font-700">{text}</span>
        <span className="fz-11">{message}</span>
      </div>
    </div>
  )
}

const formatMessageOptions = [
  { value: 'text', label: buildLabelTypeOption('text') },
  { value: 'buttons', label: buildLabelTypeOption('buttons') },
  { value: 'list', label: buildLabelTypeOption('list') }
];

const MessageOptionsSelect = ({
  chatbotOption,
  updateInfo,
  errors,
  chatbot
}) => {
  const [showExample, setShowExample] = useState(false);

  // En TikTok solo se ofrece "Números": los otros dos modos no llegan a renderizarse.
  // `formatMessageOptions` sigue completo para resolver `value`, así que un flujo que ya
  // tuviera guardado 'buttons' o 'list' lo muestra en vez de aparecer vacío.
  const availableMessageOptions = isTikTokOnlyChatbot(chatbot)
    ? formatMessageOptions.filter((el) => el.value === 'text')
    : formatMessageOptions;

  const handleSelect = (option) => {
    updateInfo('interactive', option.value);
  };

  const renderShowText = () => {
    if (showExample) return 'Ocultar ejemplo';

    return 'Mostrar ejemplo';
  };

  const renderExample = () => {
    return (
      <>
        <div className="col-md-12 px-0 mt-6">
          <span className="cursor-pointer text-blue fz-13" onClick={() => setShowExample(!showExample)}>
            <IconMC name="question-mark-circle-outline" size="base" className="tw-mr-1 tw-inline-block" />
            {renderShowText()}
          </span>
        </div>

        {showExample && (
          <>
            <div className="col-md-12 mt-20 text-center">
              <img src={listExample} style={{ border: '1px solid #DDD' }} />
            </div>

            <div className="com-md-12 text-center mt-2">
              <span className="fz-12 text-gray-light">Ejemplo de un mensaje con lista interactiva</span>
            </div>
          </>
        )}
      </>
    )
  };

  return (
    <>
      <div className="figma-field mb-0">
        <label>¿Cómo mostramos las opciones?</label>
        <span className="ml-10 error-msg fz-12">{errors.interactive}</span>
        <Select
          options={availableMessageOptions}
          placeholder="Selecciona"
          className={chatbotOption.interactive ? '' : 'select-tag'}
          classNamePrefix={chatbotOption.interactive ? '' : 'select-tag'}
          styles={selectStyles}
          onChange={handleSelect}
          value={[formatMessageOptions.find((el) => el.value == chatbotOption.interactive)]}
          name="interactive"
          components={{
            IndicatorSeparator: () => null
          }}
        />
      </div>

      {chatbotOption.interactive == 'list' && (
        <>
          {renderExample()}
        </>
      )}
    </>
  )
}

export default MessageOptionsSelect;
